const getRandomId = () => {
  return Math.random().toString(32).slice(2, 8);
};

export default getRandomId;
